export enum ELabelDate {
  Last30Days = 'l30d',
  Last3Months = 'l3m',
  Last1Year = 'l1y',
  Last2Year = 'l2y',
  Last3Year = 'l3y',
  AllDates = 'all',
}
